import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { screenwritingfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            Hire The USA's Top Screen Writers Now | Falcon Book Writing
        </title>
        <meta
          name="description"
          content="Hire the USA’s top screenwriters with Falcon Book Writing to craft professional, engaging scripts and screenplays that captivate audiences and tell your story."
        />
        <meta name="keywords" content="Screen Writers" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg screenwritingbg"
          title="Screenwriting That Brings"
          subtitle=" Stories "
          title2="to Life on Screen"
          para="Screenwriting transforms ideas into captivating on-screen experiences. Every scene, character, and line is crafted with precision to engage audiences, evoke emotion, and bring your story to life with unforgettable cinematic impact."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          title={`Creating Cinematic  `}
          subtitle="  Moments "
          title2="That Stay With Viewers"
          description={`Cinematic storytelling is about more than visuals, it’s about moments that linger in the audience’s mind long after the credits roll. Every scene, line of dialogue, and plot twist is crafted to create emotion, tension, and connection. Our screenwriting focuses on developing characters with depth, pacing that builds anticipation, and moments that balance drama, humor, or suspense to keep viewers fully engaged. Whether it’s a heart-stirring drama, an edge-of-your-seat thriller, or a captivating digital series, each scene is designed to resonate. By combining narrative structure with emotional authenticity, we ensure that every cinematic beat contributes meaningfully to the story. The result is screenwriting that not only entertains but leaves a lasting impression, a film experience that audiences remember, reflect on, and return to time and again. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={screenwritingfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
